import React, { createContext, useContext } from "react"

const AudioFilterReadOnlyContext = createContext(false)

interface AudioFilterReadOnlyProviderProps {
  children: React.ReactNode
  readOnly: boolean
}

export const AudioFilterReadOnlyProvider: React.FC<
  AudioFilterReadOnlyProviderProps
> = ({ children, readOnly }) => {
  return (
    <AudioFilterReadOnlyContext.Provider value={readOnly}>
      {children}
    </AudioFilterReadOnlyContext.Provider>
  )
}

export function useAudioFilterReadOnly(): boolean {
  return useContext(AudioFilterReadOnlyContext)
}
